import axios from "utils/axios";
import axiosOrignal from "axios";

class GeneralService {
  getMoods() {
    var mood_group_id = 1;
    return axios.get("mood", {
      params: {
        mood_group_id,
      },
    });
  }

  getBuzz() {
    var mood_group_id = 2;
    return axios.get("mood", {
      params: {
        mood_group_id,
      },
    });
  }

  createAndJoinRingCentral(team_id, data) {
    return axios.post(`team/${team_id}/meeting`, data, {
      headers: {
        "Accept-version": "2.0",
        "Cache-Control": "no-cache, private",
      },
    });
  }

  getZoomUrl() {
    return axios.get("zoom/get-oauth-url");
  }

  getColors() {
    return axios.get("user/colors");
  }

  getRingCentralUrl() {
    return axios.get("/ringcentral/get-oauth-url");
  }

  getRingCentralRefreshToken(data) {
    return axios.get("/ringcentral/auth/refresh", {
      params: {
        ...data,
      },
    });
  }

  getTodoListItemId(teamId, listItemId) {
    return axios.get(`/user/team/${teamId}/todo-list-item/${listItemId}`);
  }

  postZakToken(data) {
    return axios.post(`/zoom/auth/token`, data);
  }

  postZoomSignature(data) {
    return axios.post("/zoom/user/signature", data);
  }

  createZoomMeeting(data) {
    return axios.post("/zoom/user/meeting", data);
  }

  postGlobalSearch(data) {
    if (data.team_id === "All") {
      delete data.team_id;
    }

    return axios.get("user/search", {
      params: data,
    });
  }

  getPresignedUploadURL(payload) {
    return axios.get("s3-upload-presigned-request", {
      params: payload,
    });
  }

  generateTranscription(payload) {
    return axios.post("generate-transcription", payload);
  }

  uploadToS3(url, file, progressCallback = (progress) => {}) {
    const totalSize = file.size;

    return axiosOrignal
      .put(url, file, {
        headers: {
          "Content-Type": file.type,
        },
        onUploadProgress: (progressEvent) => {
          const progress = (progressEvent.loaded / totalSize) * 100;
          progressCallback(progress.toFixed(2));

          return;
        },
      })
      .catch((error) => {
        console.log(error.response);
      });
  }

  transcribeVideo(data) {
    return axios.post("generate-transcription", data);
  }
  // async uploadToShardSecure(file, progressCallback = (progress) => {}) {
  //   const totalSize = file.size;

  //   // Find the domain name in the Cognito user pool under App Integration->Domain name.
  //   // Like  https://Domainprefix.auth.us-east-1.amazoncognito.com/oauth2/token"
  //   const token_url = 'https://9b079430.auth.us-east-1.amazoncognito.com/oauth2/token';
  //   // The DNS name of the api endpoint
  //   // Sample https://pocdomain.demo-aws.shardsecure.com/api
  //   const shardsecure_api_url = 'https://poc-beremote.poc.aws.shardsecure.com/api';
  //   // Either us an existing client or add a new. Find the ID in the Cognito user pool under General Settings->App Clients->shardsecurenfs.
  //   const app_client_id = 'gbbcpd148gb456sjtljrgrgkn'
  //   const app_client_secret = '1jfqojdb3jsl07hc9hc7rhdus00vinoa9ie6j9lr75jkflb6te7'

  //   // Call to cognito to get the access token
  //   const auth = {
  //     app_client_id,
  //     app_client_secret
  //   };

  //   const tokens = await axiosOrignal.post(token_url, {'grant_type': 'client_credentials'}, auth);

  //   const values = {
  //     'upload_file': file,
  //     'poath' : '/',
  //   };

  //   return axiosOrignal.put(shardsecure_api_url + 'file?path=', file, {
  //     headers: {
  //       'Authorization': 'Bearer ' + tokens['access_token'],
  //       'Content-Type': file.type
  //     },
  //     onUploadProgress: progressEvent => {
  //       const progress = (progressEvent.loaded / totalSize) * 100;

  //       progressCallback(progress.toFixed(2));

  //       return;
  //     }
  //   }).catch(error => {
  //     console.log(error.response);
  //   });
  // }

  createZammadTicket(data) {
    return axios.post("zammad/tickets", data, {
      headers: {
        "Accept-version": "2.0",
      },
    });
  }
}

export default new GeneralService();
